import { combineReducers } from "redux";

// Action
const UPDATE_LOGIN_STATUS = "UPDATE_LOGIN_STATUS";

export function updateLoginStatus(userData) {
  return {
    type: UPDATE_LOGIN_STATUS,
    userData,
  };
}

// Default state
const defaultUserData = {
  isLoggedIn: false,
  userId: "",
  role: "",
  token: "",
  headerMenus: [],
};

// Try to load saved state
const savedState = sessionStorage.getItem("reduxState");
const initialState = savedState ? JSON.parse(savedState) : defaultUserData;

function userDetails(state = initialState, action) {
  switch (action.type) {
    case UPDATE_LOGIN_STATUS:
      const updatedState = {
        ...state,
        ...action.userData,
      };

      sessionStorage.setItem("reduxState", JSON.stringify(updatedState));

      return updatedState;

    default:
      return state;
  }
}

const userDataStore = combineReducers({
  userDetails,
});

export default userDataStore;
